module.exports = __webpack_public_path__ + "static/img/CYXT.b6d2e7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/CYXT.png
// module id = EkP1
// module chunks = 2